import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const accent = '#cc66ff';
const cardDark = {
  background: 'radial-gradient(ellipse at 100% 0%, rgba(153,51,255,0.55) 0%, rgba(20,0,40,0.9) 45%, #0d0d0d 70%)',
  color: '#fff',
  border: '1px solid #9933ff44',
};

const ITEMS = [
  { label: 'Fastrack', icon: '⚡', path: '/fastrack', color: accent },
  { label: 'Generation', icon: '⊕', path: '/generation-bonus', color: '#66aaff' },
  { label: 'Performance', icon: '🏆', path: '/performance-bonus', color: '#ffaa44' },
  { label: 'Reward', icon: '🎁', path: '/rewards', color: '#66ff99' },
];

const AccountStatus = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <div className="mb-4">
          <h4 style={{ color: '#fff', fontWeight: 700 }}>Account Status</h4>
          <div style={{ color: '#aaa', fontSize: 13 }}>View your bonus and reward earnings across all programs</div>
        </div>

        <Row className="g-3">
          {ITEMS.map((item) => (
            <Col xs={6} md={3} key={item.path}>
              <Card
                style={{ ...cardDark, cursor: 'pointer' }}
                className="p-3 h-100 dashboard-card text-center"
                onClick={() => navigate(item.path)}
              >
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
                  <div style={{ color: item.color, fontWeight: 700, fontSize: 15 }}>{item.label}</div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default AccountStatus;
